import React from 'react'
import Header from '../Components/Header/Header'
import Hero from '../Components/Hero/Hero'
import Featuredbox from '../Components/Featuredbox/Featuredbox'
import Carouselvideo from '../Components/Carouselvideo/Carouselvideo'
import Callaction from '../Components/Callaction/Callaction'
import Video from '../Components/Video/Video'
import Servicebox from '../Components/Servicebox/Servicebox'
import { Counterbox } from '../Components/Counterbox/Counterbox'
import Coursebox from '../Components/Coursebox/Coursebox'
import Iconbox from '../Components/Iconbox/Iconbox'
import Coursecard from '../Components/Coursecard/Coursecard'
import Enrollaction from '../Components/Enrollaction/Enrollaction'
import Authabout from '../Components/Authabout/Authabout'
import Carouselbox from '../Components/Carouselbox/Carouselbox'
import Faqsec from '../Components/Faqsec/Faqsec'
import Blogsec from '../Components/Blogsec/Blogsec'
import Recruitersec from '../Components/Recruitersec/Recruitersec'
import Reviewsec from '../Components/Reviewsec/Reviewsec'
import Partnersec from '../Components/Partnersec/Partnersec'
import Footer from '../Components/Footer/Footer'
import Appsec from '../Components/Appsec/Appsec'
import Videoreview from '../Components/Videoreviewsec/Videoreview'
import Corefeature from '../Components/Corefeature/Corefeature'
import Videoslilder from '../Components/VideoSlider/Videoslider'
import Slidericon from '../Components/SliderIcon/Slidericon'
import Whyneed from '../Components/Whyneed/Whyneed'
import Uniquefea from '../Components/UniqueFea/Uniquefea'
import Accordion from 'react-bootstrap/Accordion'
import { Helmet } from 'react-helmet-async';


const Home = () => {
    
const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [{
    "@type": "Question",
    "name": "How will Takshila courses help Fresh Graduates or VLSI Professionals?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "With the increasing complexity of chips and shrinking technology nodes, engineers are required to learn new skills or improve their skills for their career growth. We at Takshila Institute help you acquire new VLSI skills, improve your current skills, and increase your knowledge of the area you are currently working on."
    }
  },{
    "@type": "Question",
    "name": "Do you have placement assistance for your courses?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "We do have placement assistance for our students. Takshila collaborates with some select top tier companies. Students get interview opportunities with these companies. However, this depends on the students’ performance."
    }
  },{
    "@type": "Question",
    "name": "What are the salary expectations as a VLSI engineer?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "If you are a fresh graduate, you should expect from 4 to 6 lakhs. Product companies offer higher payments of up to 15 lakhs however, most of them higher from campuses."
    }
  },{
    "@type": "Question",
    "name": "What kind of certificate does one receive after attending the program?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "You will be given a course completion certification from Takshila Institute, which is recognized by all VLSI Industry companies."
    }
  },{
    "@type": "Question",
    "name": "Why should I choose Takshila Institute of VLSI Technologies?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Takshila as a training institute differentiates itself from other institutes in different ways. Our mentors are experts in the semiconductor industry who have worked extensively in various domains like Physical Design, Layout, CPU verification, Analog, and Mixed-signal, Verilog modeling, Memories, Low Power Design, and FPGA implementation using VHDL/Verilog, Furthermore, we allow you to implement projects using standard tools required in the industry, which will help you increase the weight of your resume. Additionally, our fees are lesser when compared to other training institute in the country. Finally, our training’s are conducted both on weekdays and weekends giving you the opportunity to choose when fits you."
    }
  },{
    "@type": "Question",
    "name": "How can I choose the right specialization based on my career goals?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "The right specialization depends on your educational background, interests, and long-term objectives. Institutes like Takshila VLSI often provide guidance to help students identify the most suitable learning path based on current industry requirements."
    }
  },{
    "@type": "Question",
    "name": "What skills are employers looking for in entry-level semiconductor engineers?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Employers generally seek candidates with strong technical fundamentals, practical project experience, analytical thinking, problem-solving abilities, and familiarity with industry-standard tools and workflows."
    }
  },{
    "@type": "Question",
    "name": "How important is hands-on training when preparing for a technical career?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Hands-on training is essential because it helps learners apply theoretical concepts to real-world scenarios, gain confidence with tools, and develop practical skills that employers value."
    }
  },{
    "@type": "Question",
    "name": "What should I consider before enrolling in a technical training program?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Key factors include trainer expertise, curriculum relevance, access to practical projects, learning resources, mentorship opportunities, and the availability of career support services."
    }
  },{
    "@type": "Question",
    "name": "How can structured training help bridge the gap between academics and industry?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Structured training combines theoretical knowledge with practical exposure, helping students understand industry expectations, improve technical competency, and become more job-ready."
    }
  }]
};

const pageSchema={
  "@context": "https://schema.org/",
  "@type": "WebSite",
  "name": "Takshila VLSI",
  "url": "https://www.takshila-vlsi.com/",
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://www.takshila-vlsi.com/search?q={search_term_string}",
    "query-input": "required name=search_term_string"
  }
};

const businessSchema={
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": "https://www.takshila-vlsi.com/#localbusiness",
  "name": "Takshila VLSI",
  "url": "https://www.takshila-vlsi.com/",
  "image": "https://www.takshila-vlsi.com/static/media/Logo-2.8ea769c5a593c38a2ba7.jpg",
  "logo": "https://www.takshila-vlsi.com/static/media/Logo-2.8ea769c5a593c38a2ba7.jpg",
  "description": "Takshila VLSI provides industry-oriented VLSI training programs, including ASIC Verification, Analog Layout Design, Physical Design, RTL Coding, and PERL Scripting.",
  "telephone": "+91-9742972744",
  "email": "info@takshila-vlsi.com",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Ram Arcade, 90/1B, CKB Layout, Chandra Layout, Marathahalli, Opp Innovative Multiplex",
    "addressLocality": "Bengaluru",
    "addressRegion": "Karnataka",
    "postalCode": "560037",
    "addressCountry": "IN"
  },
  "sameAs": [
    "https://www.facebook.com/TakshilaVLSIInstitute/",
    "https://www.instagram.com/vlsi.takshila/",
    "https://x.com/Takshila18",
    "https://www.youtube.com/channel/UC2Yc1pZE7G-yiaH3YT1WL1A",
    "https://www.linkedin.com/company/takshila-institute-of-vlsi-technologies"
  ]
};

const orgSchema={
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": "https://www.takshila-vlsi.com/#organization",
  "name": "Takshila VLSI",
  "url": "https://www.takshila-vlsi.com/",
  "logo": {
    "@type": "ImageObject",
    "url": "https://www.takshila-vlsi.com/static/media/Logo-2.8ea769c5a593c38a2ba7.jpg"
  },
  "description": "Takshila VLSI provides industry-oriented VLSI training programs, including ASIC Verification, Analog Layout Design, Physical Design, RTL Coding, and PERL Scripting, with practical lab training and placement assistance.",
  "email": "info@takshila-vlsi.com",
  "telephone": "+91-9742972744",
  "sameAs": [
    "https://www.facebook.com/TakshilaVLSIInstitute/",
    "https://www.instagram.com/vlsi.takshila/",
    "https://x.com/Takshila18",
    "https://www.youtube.com/channel/UC2Yc1pZE7G-yiaH3YT1WL1A",
    "https://www.linkedin.com/company/takshila-institute-of-vlsi-technologies"
  ],
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+91-9742972744",
    "email": "info@takshila-vlsi.com",
    "contactType": "customer support",
    "availableLanguage": [
      "English"
    ]
  }
};

  return (
    <div>
        <Helmet>
            <title>VLSI Training Institute in Bangalore & Hyderabad, India | Takshila</title>
            <meta name="description" content="Get job-oriented VLSI training in Bangalore and Hyderabad with expert-led courses, practical projects, industry skills, and placement support from Takshila VLSI." />
            <link rel="canonical" href='https://www.takshila-vlsi.com/' />

            <meta property="og:locale" content="en_IN" />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="Takshila VLSI" />
            <meta property="og:title" content="VLSI Training Institute in Bangalore & Hyderabad | Takshila" />
            <meta property="og:description" content="Get job-oriented VLSI training in Bangalore and Hyderabad with expert-led courses, practical projects, industry skills, and placement support from Takshila VLSI." />
            <meta property="og:url" content="https://www.takshila-vlsi.com/" />
            <meta property="og:image" content="https://www.takshila-vlsi.com/og-image.jpg" />
            <meta property="og:image:alt" content="Takshila VLSI training programs" />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="VLSI Training Institute in Bangalore & Hyderabad | Takshila" />
            <meta name="twitter:description" content="Get job-oriented VLSI training in Bangalore and Hyderabad with expert-led courses, practical projects, industry skills, and placement support from Takshila VLSI." />
            <meta name="twitter:image" content="https://www.takshila-vlsi.com/og-image.jpg" />

            <meta property="article:modified_time" content="2024-12-16T07:02:16+00:00"/>
            
            <script type="application/ld+json">
            {JSON.stringify(faqSchema)}
            </script>
            <script type="application/ld+json">
            {JSON.stringify(pageSchema)}
            </script>
        
      </Helmet>
    <Header/>
    <Hero/>
    <Slidericon/>
    <div class="container text-center ws-section">
        <div class="row">
            <div class="col-lg-12">
                <h2 class="ws-section_heading pd-03">Welcome to Takshila VLSI<br/>
                Watch Our Free Demo Sessions</h2>
            </div>
        </div>
        </div>
    <Videoslilder/>
    <Callaction/>
    <Video/>
    <Counterbox/>
    <Coursebox/>
    <Servicebox/>
    <Iconbox/>
    <Coursecard/>
    <Corefeature/>
    <Uniquefea/> 
    <Carouselbox/>
    <Faqsec/>
    <Blogsec/>
    <Recruitersec/>
    <Reviewsec/>
    <Appsec/> 
    <Videoreview/>
    <Enrollaction/> 
    <Partnersec/> 
    <Whyneed/> 
    <div class="faq-section ws-section pb-lg-5">
                <div class="container">
                    <div class="row pb-5">
                        
                        <div class="col-lg-12 align-self-center">
                        <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>1. How can I choose the right specialization based on my career goals?</Accordion.Header>
                                <Accordion.Body>
                                The right specialization depends on your educational background, interests, and long-term objectives. Institutes like Takshila VLSI often provide guidance to help students identify the most suitable learning path based on current industry requirements.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>2. What skills are employers looking for in entry-level semiconductor engineers?</Accordion.Header>
                                <Accordion.Body>
Employers generally seek candidates with strong technical fundamentals, practical project experience, analytical thinking, problem-solving abilities, and familiarity with industry-standard tools and workflows.                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>3. How important is hands-on training when preparing for a technical career?</Accordion.Header>
                                <Accordion.Body>
Hands-on training is essential because it helps learners apply theoretical concepts to real-world scenarios, gain confidence with tools, and develop practical skills that employers value.                                </Accordion.Body>
                            
                            </Accordion.Item>
                            <Accordion.Item eventKey="3">
                                <Accordion.Header>4. What should I consider before enrolling in a technical training program?</Accordion.Header>
                                <Accordion.Body>
Key factors include trainer expertise, curriculum relevance, access to practical projects, learning resources, mentorship opportunities, and the availability of career support services.                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="4">
                                <Accordion.Header>5. How can structured training help bridge the gap between academics and industry?</Accordion.Header>
                                <Accordion.Body>
                                Structured training combines theoretical knowledge with practical exposure, helping students understand industry expectations, improve technical competency, and become more job-ready.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="5">
                                <Accordion.Header>6. What additional support can help students succeed beyond classroom learning?</Accordion.Header>
                                <Accordion.Body>
                                Mentorship, mock interviews, resume guidance, project reviews, career counseling, and networking opportunities can significantly improve a student's readiness for professional roles. Takshila VLSI offers several of these support mechanisms as part of its learning ecosystem.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="6">
                                <Accordion.Header>7. How can structured training help bridge the gap between academics and industry?How can fresh graduates improve their chances of securing their first technical role?</Accordion.Header>
                                <Accordion.Body>
                                Fresh graduates should focus on developing practical skills, completing projects, building a strong portfolio, preparing for interviews, and staying updated with industry trends and technologies.
                                </Accordion.Body>
                            </Accordion.Item>
                            </Accordion>
                        </div>
                    </div>
                    
                    
        </div>
    </div>
   
    <Footer/> </div>
  )
}

export default Home